import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useCareerLearningTopicsBySlug = (slug) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['digital-careers-learning-topics', slug],
    queryFn: async () => {
      const result = await restClient({ url: `${prefix}/digital-careers/${slug}/learning-topics`});
      return result;
    },
    enabled: !!slug, 
    staleTime: 0,
    cacheTime: 0,
  });
};
